// In its own file to avoid dependency cycles
export const containerName = 'PRICESCOPE';
